

// -- Split menu -- //
function moveElement(elementSelector, targetSelectors) {
	const element = document.querySelector(elementSelector);
	const footer = document.querySelector('footer');

	if (!element) {
		console.error(`Prvek ${elementSelector} nebyl nalezen`);
		return;
	}

	let moved = false;

	for (const targetSelector of targetSelectors) {
		const target = document.querySelector(targetSelector);
		if (target) {
			target.insertAdjacentElement('afterend', element);
			moved = true;
			break;
		}
	}

	if (!moved && footer) {
		footer.insertAdjacentElement('beforebegin', element);
	}
}


//On funkce, na kliknutí a zavolání funkce
function on(eventType, selector, callback) {
	document.addEventListener(eventType, function (e) {
		let targetElement = e.target;
		while (targetElement && targetElement !== document) {
			if (targetElement.matches(selector)) {
				e.preventDefault();
				callback.call(targetElement, e);
				break;
			}
			targetElement = targetElement.parentElement;
		}
	});
}

const splitMenu = () => {
	const menuWrapper = document.querySelector('#navigation .navigation-in')
	if (menuWrapper) {
		setTimeout(() => {
			let menuItems = menuWrapper.querySelectorAll('.menu-level-1>li:not(.appended-category)')
			let menuHelper = document.querySelector('.menu-helper')
			let menuWrapperStyle = window.getComputedStyle(menuWrapper)
			menuItems.forEach((item) => {
				let offsetRight = item.offsetLeft + item.offsetWidth
				const itemInHelper =
					item.id === 'nav-manufacturers'
						? menuHelper.querySelector('#nav-manufacturers')
						: menuHelper.querySelector('.' + item.classList[0])
				if (offsetRight > menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight)) {
					if (itemInHelper) {
						itemInHelper.classList.remove('splitted')
					}
					item.classList.add('splitted')
				} else {
					if (itemInHelper) {
						itemInHelper.classList.add('splitted')
					}
					item.classList.remove('splitted')
				}
			})
			if (menuHelper.querySelector('.menu-level-1 > li:not(.splitted):not(.appended-category)')) {
				menuHelper.classList.remove('empty')
				menuWrapper.classList.remove('fitted')
			} else {
				menuHelper.classList.add('empty')
				menuWrapper.classList.add('fitted')
			}
		}, 200)
	}
}

shoptet.menu.splitMenu = splitMenu

// CAROUSEL
const handleCarousel = () => {
	const carousel = document.querySelector('#carousel .carousel-inner');
	if (carousel) {
		let observer = new MutationObserver((mutationList) => {
			let currentItem;
			mutationList.forEach((mutation) => {
				if (mutation.target.className === 'item active') {
					currentItem = mutation.target;
				}
			});
			if (typeof currentItem == 'undefined') return;
			let actualIndex = [...document.querySelectorAll('.carousel-inner .item')].indexOf(currentItem),
				dotsList = document.querySelectorAll('.carousel-dots li');
			dotsList.forEach((dot) => {
				dot.classList.remove('dot-active');
			});
			dotsList[actualIndex].classList.add('dot-active');
		});
		let dotsCounter = 0,
			dotsList = document.createElement('ul');
		dotsList.classList.add('carousel-dots');
		carousel.querySelectorAll('.item').forEach((item, index) => {
			dotsCounter += 1;
			let dotEl = document.createElement('li');
			dotsList.appendChild(dotEl);
			if (index === 0) dotEl.classList.add('dot-active');
			dotEl.addEventListener('click', (e) => {
				e.preventDefault();
				document.querySelector('.carousel-inner .item.active').classList.remove('active');
				let targetItem = document.querySelectorAll('.carousel-inner .item')[index];
				const targetItemMedia = targetItem.querySelector('img, video');
				if (targetItemMedia) {
					if (targetItemMedia.tagName.toLowerCase() === 'img' && !targetItemMedia.src) {
						targetItemMedia.src = targetItemMedia.getAttribute('data-src');
					} else if (targetItemMedia.tagName.toLowerCase() === 'video') {
						const sourceElement = targetItemMedia.querySelector('source');
						if (sourceElement && !sourceElement.src) {
							sourceElement.src = sourceElement.getAttribute('data-src');
							targetItemMedia.load(); // Reload the video to apply the new source
						}
					}
				}
				targetItem.classList.add('active');
			});
			observer.observe(item, {
				attributes: true,
				attributeFilter: ['class'],
			});
		});
		carousel.appendChild(dotsList);
	}

	// const videoObserver = new IntersectionObserver((entries, observer) => {
	// 	for (const entry of entries) {
	// 		const video = entry.target;
	// 		if (entry.isIntersecting) {
	// 			video.play();
	// 			// Disconnect the observer for this video
	// 			observer.unobserve(video);
	// 		} else {
	// 			video.pause();
	// 		}
	// 	}
	// }, {
	// 	rootMargin: '0px 0px 0px 0px',
	// 	threshold: 0.1 // Adjust threshold as needed
	// });

	// // Select all video elements and observe them
	// document.querySelectorAll('video').forEach((video) => {
	// 	videoObserver.observe(video);
	// });
};
if (shoptetPage == 'homepage') {
	handleCarousel();
}

// FLAGS and card
const handleFlags = (product) => {
	const flagsDefault = product.querySelector('.flags-default')
	const flagsExtra = product.querySelector('.flags-extra')

	const preowned = product.querySelector('.flag-preowned')
	const unworn = product.querySelector('.flag-unworn')
	const yearFlags = Array.from(product.querySelectorAll('.flag')).filter(flag => {
		return /\bflag-\d{4}\b/.test(flag.className);
	});
	const pBottom = product.querySelector('.p-bottom');

	const specialHolder = document.createElement('div');
	specialHolder.classList.add('special-holder');
	if (specialHolder && pBottom) {
		pBottom.prepend(specialHolder);
		if (preowned) specialHolder.appendChild(preowned);
		if (unworn) specialHolder.appendChild(unworn);
		if (yearFlags.length) yearFlags.forEach(flag => specialHolder.appendChild(flag));
	}


	if (flagsDefault && flagsExtra) {
		flagsDefault.appendChild(flagsExtra)
		flagsDefault.classList.add('contains-extra')
	}

}

const handleTextLayout = (product) => {
	// const priceStandard = product.querySelector('.price-standard')
	const prices = product.querySelector('.prices');
	const pDesc = product.querySelector('.p-desc');
	const pInIn = product.querySelector('.p-in-in');


	if (pInIn && pDesc) pInIn.prepend(pDesc);
	if (pInIn && prices) pInIn.appendChild(prices);


	const code = product.querySelector('.p-code');
	const codeText = window.codeText.find(item => item.language === shoptetLang).text;
	const codeSpan = code.querySelector('span');

	code.innerHTML = codeText + codeSpan.innerHTML;

	if (pInIn && code) {
		pInIn.appendChild(code);
	}


	// if (priceStandard && prices) prices.prepend(priceStandard)
}
// RATINGS
// const handleRatings = (product) => {
// 	if (product.querySelector('.custom-ratings')) return
// 	const ratingsValue = product.querySelector('.stars-wrapper')
// 	const productImage = product.querySelector('.image')
// 	if (ratingsValue) {
// 		const customRatings = document.createElement('div')
// 		customRatings.classList.add('custom-ratings', 'stars')
// 		customRatings.innerHTML = `
// 			${ratingsValue.getAttribute('data-micro-rating-value') || 0} <span class="star star-on"></span> 
// 		`
// 		productImage.appendChild(customRatings)
// 	}
// }
// const handleProductAvailability = (product) => {
// 	const availability = product.querySelector('.availability');
// 	const pBottom = product.querySelector('.p-in .p-in-in');
// 	if (availability && pBottom) pBottom.appendChild(availability);
// }
const mmAllProducts = document.querySelectorAll('.products-block .product')
if (mmAllProducts.length) {
	mmAllProducts.forEach((product) => handleFlags(product))
	mmAllProducts.forEach((product) => handleTextLayout(product))
	// mmAllProducts.forEach((product) => handleRatings(product))
	// mmAllProducts.forEach((product) => handleProductAvailability(product))
}
document.addEventListener('ShoptetDOMContentLoaded', () => {
	const mmAllProducts = document.querySelectorAll('.products-block .product')
	if (mmAllProducts.length) {
		mmAllProducts.forEach((product) => handleFlags(product))
		mmAllProducts.forEach((product) => handleTextLayout(product))
		// mmAllProducts.forEach((product) => handleRatings(product))
		// mmAllProducts.forEach((product) => handleProductAvailability(product))
	}
})


// FOOTER-BOTTOM
function footerBilling() {
	const footerBottom = document.querySelector('.footer-bottom');
	const footerGlobal = document.querySelector('#footer');
	if (footerBottom && footerGlobal) {
		const footerBottomWrapper = document.createElement('div');
		footerBottomWrapper.classList.add('footer-bottom-wrapper');
		footerBottomWrapper.appendChild(footerBottom);
		footerGlobal.parentElement.insertBefore(footerBottomWrapper, footerGlobal.nextElementSibling);
		const signature = footerBottom.querySelector('#signature');
		if (signature) {
			signature.style.display = 'flex';
			const platebniMetodyEl = document.createElement('img');
			platebniMetodyEl.classList.add('platebni-metody');
			platebniMetodyEl.src = '/user/documents/upload/miranda/platebni_metody.png';
			platebniMetodyEl.alt = 'Platební metody';
			signature.parentElement.insertBefore(platebniMetodyEl, signature.nextElementSibling);
		}
	}
}

footerBilling();

// PRODUCT DETAIL
const createShpTabLink = (text, anchor, id) => {
	const shpTabLi = document.createElement('li')
	const shpTabLink = document.createElement('a')
	shpTabLi.classList.add('shp-tab')
	shpTabLi.appendChild(shpTabLink)
	shpTabLink.classList.add('shp-tab-link')
	shpTabLink.href = anchor
	shpTabLink.innerHTML = text
	if (id) {
		shpTabLi.id = id
	}
	return shpTabLi
}

if (document.body.classList.contains('type-detail')) {
	const pDetailTabs = document.querySelector('#p-detail-tabs')
	const tabContent = document.querySelector('#tab-content')

	const customMobileSlider = document.querySelector('.custom-slider-wrapper')
	setTimeout(() => {
		// console.log(customMobileSlider)
	}, 3000);

	// if (customMobileSlider) {
	// 	$(customMobileSlider).slick({
	// 		infinite: false,
	// 		arrows: false,
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		dots: true,
	// 	})
	// }
	swiperize({
		containers: '.custom-slider-wrapper',
		slide: '.p-main-image',
		customOptions: {
			fullscreen: false,
			infinity: false,
			dots: true,
			arrows: false,
			scrollbar: false,
			lazyPrevNext: true
		},
		swiperOptions: {
			direction: 'horizontal',
			speed: 800,
			spaceBetween: 20,
			slidesPerView: 1,

		},
	});
	// DLOUHY POPIS + OSTATNI TABY


	const ratingTab = document.querySelector('#ratingTab')
	if (ratingTab) {
		const ratingTabHeading = document.createElement('h3')
		ratingTabHeading.innerHTML = 'Hodnocení'
		ratingTab.prepend(ratingTabHeading)
	}



	const relatedProducts = document.querySelector('.products-related')
	const relatedProductsHeading = document.querySelector('.products-related-header')
	if (relatedProducts && relatedProductsHeading) {
		// relatedProductsHeading.innerText = 'Doporučujeme';
		const titleText = relatedProductsHeading.innerText;




		const relatedProductsCount = relatedProducts.querySelectorAll('.product').length;
		const tabContent = document.querySelector('#tab-content')
		const relatedProductsLink = createShpTabLink(titleText, '#relatedProducts', 'relatedProductsTab');
		// if (pDetailTabs.children[2]) {
		// 	pDetailTabs.insertBefore(relatedProductsLink, pDetailTabs.children[2]);
		// } else {
		pDetailTabs.appendChild(relatedProductsLink);
		// }
		const productContent = document.querySelector('#content')
		relatedProductsHeading.classList.add('homepage-group-title')
		// relatedProductsHeading.innerHTML = `Další produkty z kolekce`
		const relatedProductsTab = document.createElement('div')
		// relatedProductsTab.classList.add('tab-pane')
		relatedProductsTab.id = 'relatedProducts'
		relatedProductsTab.appendChild(relatedProductsHeading)
		relatedProductsTab.appendChild(relatedProducts)
		productContent.appendChild(relatedProductsTab)




		const desc = document.querySelector('.basic-description')
		// desc.parentNode.insertBefore(relatedProductsTab, desc.nextSibling)

		// const shpTabsWrapper = document.querySelector('.shp-tabs-wrapper')
		// const wholeProd = document.querySelector('#relatedProducts')
		// if (shpTabsWrapper && wholeProd) {
		// 	shpTabsWrapper.parentNode.insertBefore(wholeProd, shpTabsWrapper)
		// }
		// productContent.appendChild(relatedProductsTab);

		// Find .products-block inside #relatedProducts and change its class
		// const productsBlock = wholeProd.querySelector('.products-block')
		// if (productsBlock) {
		// 	productsBlock.classList.remove('products-block')
		// 	productsBlock.classList.add('products-inline')

		// }

		// const productBlock = wholeProd.querySelector('.products');
		// const allProducts = wholeProd.querySelectorAll('.products .product');
		// allProducts.forEach((product, index) => {
		// 	const img = product.querySelector('img');
		// 	if (img && img.dataset.src) {
		// 		img.src = img.dataset.src;
		// 	}
		// });
		// if (allProducts.length > 4) {
		// 	const showMoreBtn = document.createElement('a');
		// 	showMoreBtn.className = 'btn btn-border';
		// 	showMoreBtn.textContent = 'Zobrazit další';
		// 	showMoreBtn.style.cursor = 'pointer';

		// 	productBlock.appendChild(showMoreBtn); // Changed to append the button at the end of the productBlock

		// 	showMoreBtn.addEventListener('click', function () {
		// 		const inactiveProducts = wholeProd.querySelectorAll('.products .product.inactive');
		// 		inactiveProducts.forEach(product => {
		// 			product.classList.remove('inactive');
		// 			product.classList.add('active');
		// 		});
		// 		this.style.display = 'none';
		// 	});
		// }
		// $(relatedProducts).slick(productsSlickSettings)


		swiperize({
			containers: '.products-related',
			slide: '.product',
			customOptions: {
				fullscreen: false,
				infinity: true,
				dots: false,
				arrows: true,
				scrollbar: false,
				lazyPrevNext: true
			},
			swiperOptions: {
				direction: 'horizontal',
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 16,

				breakpoints: {
					1300: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
					993: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 16,
					},

				},
			},
		});
	}

	const alternativeProductsTabLink = document.querySelector('.shp-tab-link[href="#productsAlternative"]')
	if (alternativeProductsTabLink) alternativeProductsTabLink.parentElement.remove()
	const alternativeProducts = document.querySelector('#productsAlternative')
	if (alternativeProducts) {
		alternativeProducts.classList.remove('tab-pane', 'fade')
		const alternativeProductsHeading = document.createElement('h2')
		alternativeProductsHeading.classList.add('homepage-group-title')
		const alternativeNadpisy = alternativeNadpis.find((item) => item.language === shoptetLang)
		if (alternativeNadpisy) {
			alternativeProductsHeading.innerHTML = alternativeNadpisy.text
		}
		const productContent = document.querySelector('#content')
		// const helpUSP = document.querySelector('#content > .benefitBanner')
		// if (helpUSP) {
		// 	helpUSP.parentElement.insertBefore(alternativeProductsHeading, helpUSP)
		// 	helpUSP.parentElement.insertBefore(alternativeProducts, helpUSP)
		// } else {

		const holder = document.createElement('div');
		holder.classList.add('holder');
		alternativeProducts.insertBefore(alternativeProductsHeading, alternativeProducts.firstChild);
		productContent.appendChild(alternativeProducts)
		// }
		// $(alternativeProducts.querySelector('.products-block')).slick(productsSlickSettings)

		swiperize({
			containers: '.products-alternative',
			slide: '.product',
			customOptions: {
				fullscreen: false,
				infinity: true,
				dots: false,
				arrows: true,
				scrollbar: false,
				lazyPrevNext: true
			},
			swiperOptions: {
				direction: 'horizontal',
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 16,

				breakpoints: {
					1300: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
					993: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 16,
					},

				},
			},
		});
	}





	const parametersTabContent = document.querySelector('#description .extended-description');

	if (parametersTabContent) {
		const specificationText = window.specificationTabText.find(item => item.language === shoptetLang).text;
		const parametersTab = createShpTabLink(specificationText, '#parameters');
		const descriptionTab = document.querySelector('.shp-tab[data-testid="tabDescription"]');
		descriptionTab.after(parametersTab);
		parametersTabContent.id = 'parameters';
	}



	const shpTabLinks = document.querySelectorAll('.shp-tab-link');
	if (shpTabLinks.length) {
		shpTabLinks.forEach((link) => {
			link.removeAttribute('role');
			link.removeAttribute('data-toggle');

			// Odstranění závorek a čísel z textu odkazu
			link.textContent = link.textContent.replace(/\(\d+\)/g, '').trim();
		});
	}
	const targetNode = document.querySelector('.shp-tabs-row');

	if (targetNode) {
		const config = { childList: true, subtree: true };

		const callback = function (mutationsList, observer) {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const hiddenLinks = document.querySelector('.shp-tabs-row .hidden-links');
					const shpTabsRow = document.querySelector('.shp-tabs-row .shp-tabs');

					if (hiddenLinks && shpTabsRow) {
						// Přesunout všechny .shp-tab do .shp-tabs-row .shp-tabs
						const shpTabs = hiddenLinks.querySelectorAll('.shp-tab');
						shpTabs.forEach(tab => {
							shpTabsRow.appendChild(tab);
						});

						// Odstranit .hidden-links
						hiddenLinks.remove();
					}
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);

		// Přidat posluchače událostí pro resize a orientationchange
		window.addEventListener('resize', () => observer.observe(targetNode, config));
		window.addEventListener('orientationchange', () => observer.observe(targetNode, config));
	}


}

// CART
const handleCart = () => {
	const pageHeader = document.querySelector('#header')
	const cartHeader = document.querySelector('.cart-content .cart-header')
	const cartHeaderHelper = document.querySelector('.cart-header-wrapper')
	const search = document.querySelector('.search')
	const headerTop = document.querySelector('.header-top')
	// console.log(search)
	// console.log(headerTop)
	// if (search && headerTop) {
	// 	headerTop.appendChild(search)
	// }
	if (cartHeader && !cartHeaderHelper) {
		const cartHeaderWrapper = document.createElement('div')
		cartHeaderWrapper.classList.add('cart-header-wrapper')
		cartHeaderWrapper.appendChild(cartHeader)
		cartHeader.classList.add('container')
		pageHeader.parentElement.insertBefore(cartHeaderWrapper, pageHeader.nextElementSibling)
	} else if (cartHeader) {
		cartHeader.remove()
	}

	// const discountForm = document.querySelector('.discount-coupon')
	// const summaryWrapper = document.querySelector('.summary-wrapper')
	// if (discountForm && summaryWrapper) {
	// 	summaryWrapper.prepend(discountForm)
	// 	const discountInput = discountForm.querySelector('input')
	// 	discountInput.placeholder = 'Vložte kód'
	// }
	const sidebarCart = document.querySelector('.sidebar-in-cart')
	// const sidebarCart = document.querySelector('.sidebar-in-cart .box[data-testid="tableCart"]')
	const extraDelivery = document.querySelector('.extra.delivery')
	if (extraDelivery && sidebarCart) {
		if (dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft <= 0) extraDelivery.classList.add('free-shipping')
		sidebarCart.appendChild(extraDelivery)
		// sidebarCart.prepend(extraDelivery)
	}

	const overallWrapper = document.querySelector('.overall-wrapper')
	const cartFooter = document.createElement('div')
	cartFooter.classList.add('cart-footer')
	if (overallWrapper) overallWrapper.appendChild(cartFooter)
	const cartMail = document.querySelector('.contact-box .mail')
	const cartPhone = document.querySelector('.contact-box .tel')

	const sidebarNextStep = document.querySelector('#checkoutSidebar .next-step')
	const orderSummary = document.querySelector('#summary-box')
	if (sidebarNextStep && orderSummary) orderSummary.appendChild(sidebarNextStep)

	// const nextStep = document.querySelector(".next-step-back");
	// if(nextStep) {

	// }

	const sidebarConsents = document.querySelectorAll('#checkoutSidebar .consents')
	const summaryItemPrice = document.querySelector('#checkoutSidebar .order-summary-item.price')
	if (sidebarConsents.length && summaryItemPrice) {
		sidebarConsents.forEach((consent) => {
			summaryItemPrice.parentElement.insertBefore(consent, summaryItemPrice.nextElementSibling)
		})
	}
	if (window.innerWidth <= 1300) {
		const backHolder = document.querySelector('.cart-inner');
		const backHold = document.querySelector(".back-shopping-link");
		if (backHolder && backHold) {
			backHolder.appendChild(backHold);
		}
	}
	// const backToShopButtons = document.querySelectorAll('.back-to-shop')
	// if (backToShopButtons.length) {
	// 	backToShopButtons.forEach((button) => {
	// 		button.innerText = 'ZPĚT K NÁKUPNÍMU KOŠÍKU'
	// 	})
	// }

	// const backToShop = document.querySelector('.back-to-shop')
	// if (backToShop) {
	// 	// console.log(backToShop)
	// 	const backToShopLinks = document.querySelector('.back-shopping-link')
	// 	if (backToShopLinks) {
	// 		// console.log(backToShopLinks)
	// 		backToShopLinks.appendChild(backToShop);
	// 	}
	// }
	const paymentInfoTooltips = document.querySelectorAll('.payment-info .show-tooltip')
	if (paymentInfoTooltips.length) {
		paymentInfoTooltips.forEach((tooltip) => {
			tooltip.innerText = 'i'
		})
	}
	const handleFreeRecapitulation = () => {
		setTimeout(() => {
			const recapItemPrices = document.querySelectorAll('.recapitulation-shipping-billing-info > span')
			if (recapItemPrices.length) {
				recapItemPrices.forEach((price) => {
					if (price.innerText.toUpperCase().includes('ZDARMA')) {
						price.classList.add('for-free')
					} else {
						price.classList.remove('for-free')
					}
				})
			}
		}, 100)
	}
	document.addEventListener('ShoptetShippingMethodUpdated', handleFreeRecapitulation)
	document.addEventListener('ShoptetBillingMethodUpdated', handleFreeRecapitulation)

	const recapItemPrices = document.querySelectorAll('span[data-testid="recapItemPrice"]')
	if (recapItemPrices.length) {
		recapItemPrices.forEach((price) => {
			if (price.innerText.toUpperCase().includes('ZDARMA')) {
				price.classList.add('for-free')
			} else {
				price.classList.remove('for-free')
			}
		})
	}

	const continueOrderButton = document.querySelector('#continue-order-button')
	if (continueOrderButton) {
		continueOrderButton.innerText = 'Pokračovat v objednávce' //jazyk
	}

	// const relatedProductsBuyButton = document.querySelectorAll('.cart-related-product .add-to-cart-button')
	// if (relatedProductsBuyButton.length) {
	// 	relatedProductsBuyButton.forEach((button) => {
	// 		button.innerText = 'Koupit' //jazyk
	// 	})
	// }

	const footerCheck = document.querySelector('.ordering-process-footer')
	if (!footerCheck) {
		const cartProjectMail = document.querySelector('.contact-box .mail')
		const cartProjectPhone = document.querySelector('.contact-box .tel')
		const orderingProcessFooter = document.createElement('footer')
		orderingProcessFooter.classList.add('ordering-process-footer')
		orderingProcessFooter.innerHTML = `
			<div class="container">
				<div class="secure-payment">
					<span>Bezpečná platba</span>
					<img src="/user/documents/upload/miranda/platebni_metody.png" width="286" height="23" alt="Visa, MasterCard, Maestro, PayPal"/>
				</div>
				<div class="contact-box phone-wrapper">
				<span>Po - Ne 10:00 - 19:00</span>
				</div>
				<div class="contact-box mail-wrapper">
					<span>Reagujeme do 24 hodin</span> 
				</div>
			</div>
		` //jazyk
		overallWrapper.appendChild(orderingProcessFooter)
		const orderingProcessFooterPhoneWrapper = orderingProcessFooter.querySelector('.phone-wrapper')
		const orderingProcessFooterMailWrapper = orderingProcessFooter.querySelector('.mail-wrapper')
		if (cartProjectPhone) {
			const clonedPhone = cartProjectPhone.cloneNode(true);
			orderingProcessFooterPhoneWrapper.prepend(clonedPhone);
			const phoneElement = orderingProcessFooter.querySelector('.phone-wrapper .tel');
			if (phoneElement) {
				phoneElement.classList.add('project-phone');
				phoneElement.classList.remove('tel'); // Odstranění třídy 'tel'
			}
		}

		if (cartProjectMail) {
			const clonedMail = cartProjectMail.cloneNode(true);
			orderingProcessFooterMailWrapper.prepend(clonedMail);
			const mailElement = orderingProcessFooter.querySelector('.mail-wrapper .mail a');
			if (mailElement) {
				mailElement.classList.add('project-email');
				mailElement.classList.remove('mail'); // Odstranění třídy 'mail'
			}
		}
	}
	if (shoptetPage === 'cart') {
		const productsInCart = document.querySelectorAll('.cart-table tr.removeable[data-micro="cartItem"]')
		productsInCart.forEach((product) => {
			const productSKU = product.getAttribute('data-micro-sku')
			const productName = product.querySelector('.p-name')
			if (productSKU && productName) {
				const productSKUEl = document.createElement('div')
				productSKUEl.classList.add('product-sku')
				productSKUEl.innerHTML = `Kód: ${productSKU}`
				productName.appendChild(productSKUEl)
			}
		})
	}

	const products = document.querySelectorAll('tbody [data-micro="cartItem"]')
	if (products.length) {
		products.forEach((product) => {
			const pQuantity = product.querySelector('.p-availability ')
			const pName = product.querySelector('.p-name')
			const mainLink = pName.querySelector('.main-link')

			if (pQuantity && pName && mainLink) {
				const quantityHtml = pQuantity.innerHTML
				mainLink.insertAdjacentHTML('afterend', `<div class="availability">${quantityHtml}</div>`)
			}
		})
	}



	const cartSummary = document.querySelector('.summary-wrapper')
	if (cartSummary) {
		const box = cartSummary.querySelector('.box')
		const upperSummaryReayl = document.querySelector('.upper-summary')
		if (box) {
			const upperSummary = document.createElement('div')
			upperSummary.classList.add('upper-summary')
			box.prepend(upperSummary)

			const cartContentSummary = document.querySelector('.cart-content .cart-summary')
			if (cartContentSummary) {
				const cartInner = document.querySelector('.cart-inner')
				box.appendChild(cartContentSummary)

				const h4 = cartContentSummary.querySelector('h4')
				if (h4) {
					h4.innerHTML = extraGiftTitles.find((item) => item.language === shoptetLang)?.text
					if (!cartContentSummary.querySelector('.discount-coupon')) {
						h4.style.display = 'none'
					}

					// h4.addEventListener('click', function () {
					// 	this.classList.toggle('active')
					// 	const discountCoupon = cartContentSummary.querySelector('.discount-coupon')
					// 	if (discountCoupon) {
					// 		discountCoupon.classList.toggle('active')
					// 	}
					// })
				}
				if (cartContentSummary.querySelector('.discount-coupon .applied-coupon')) {
					const discountCoupon = cartContentSummary.querySelector('.discount-coupon')
					h4.classList.add('active')
					discountCoupon.classList.add('active')
				}

				const button = cartContentSummary.querySelector('.discount-coupon button')
				if (button) {
					button.innerHTML = 'Uplatnit' //jazyk
				}
				const freeGift = cartContentSummary.querySelector('.free-gift')
				if (freeGift) {
					const h4Gift = document.createElement('h4')
					h4Gift.innerHTML = 'Dárek'
					box.insertBefore(freeGift, upperSummary)
					freeGift.prepend(h4Gift)
				}
			}

			const priceHolder = document.createElement('div')
			priceHolder.classList.add('price-holder')
			upperSummary.appendChild(priceHolder)

			// if (totalSaved > 0) {
			// 	const saveHolder = document.createElement('span');
			// 	saveHolder.classList.add('save-holder');
			// 	const totalSavedActualCurrency = totalSaved.ShoptetFormatAsCurrency();
			// 	saveHolder.innerHTML = `Ušetříte: ${totalSavedActualCurrency}`;
			// 	priceHolder.appendChild(saveHolder);
			// }

			const priceWrapper = cartSummary.querySelector('.price-wrapper')
			if (priceWrapper) {
				priceHolder.appendChild(priceWrapper)
			}

			const shipping = document.querySelector('.extra.delivery')
			if (shipping) {
				// upperSummary.insertAdjacentElement('afterend', shipping)
				cartSummary.prepend(shipping)
			}
		}
	}
	const nextStepH = document.querySelector(".next-step");
	if (nextStepH) {
		const upperSummary = document.querySelector('.upper-summary');
		if (upperSummary) {
			upperSummary.appendChild(nextStepH);
		}
	}

	if (document.querySelector('body').classList.contains('id--9')) {
		const cartH2 = document.createElement('h2')
		const h2 = document.querySelector('.cart-row .col-md-8 h2')
		if (cartH2 && !h2) {
			cartH2.innerHTML = itemsCartTitle.find((item) => item.language === shoptetLang)?.text
			const row = document.querySelector('.cart-row .col-md-8 .cart-content')
			if (row) {
				row.insertBefore(cartH2, row.firstChild)
			}
		}
	}
}
if (document.body.classList.contains('ordering-process')) {
	handleCart()
	document.addEventListener('ShoptetDOMCartContentLoaded', handleCart)

	// const allCartProducts = document.querySelectorAll('.cart-table tbody tr[data-micro="cartItem"], .free-gift .free-gifts-wrapper')
	// if (allCartProducts.length > 0) {
	// 	let cartProductsData = []
	// 	allCartProducts.forEach((product) => {
	// 		let productData = {
	// 			sku: product.getAttribute('data-micro-sku') || product.querySelector('.free-gift-name')?.innerHTML,
	// 			imageHTML: product.querySelector('.cart-p-image, .free-gifts-img')?.innerHTML,
	// 		}
	// 		cartProductsData.push(productData)
	// 	})
	// 	sessionStorage.setItem('cartProductsData', JSON.stringify(cartProductsData))
	// }

	// const cartItems = document.querySelectorAll('.cart-items .cart-item, .gift-items span[data-testid="recapItemName"]')
	// if (cartItems.length > 0) {
	// 	let cartProductsData = JSON.parse(sessionStorage.getItem('cartProductsData'))
	// 	if (!cartProductsData || cartItems.length > cartProductsData.length) {
	// 		fetch('/kosik/')
	// 			.then((response) => response.text())
	// 			.then((data) => {
	// 				const parser = new DOMParser()
	// 				const doc = parser.parseFromString(data, 'text/html')
	// 				const allCartProducts = doc.querySelectorAll(
	// 					'.cart-table tbody tr[data-micro="cartItem"], .free-gift .free-gifts-wrapper'
	// 				)
	// 				cartProductsData = []
	// 				allCartProducts.forEach((product) => {
	// 					let productData = {
	// 						sku: product.getAttribute('data-micro-sku') || product.querySelector('.free-gift-name')?.innerHTML,
	// 						imageHTML: product.querySelector('.cart-p-image, .free-gifts-img')?.innerHTML,
	// 					}
	// 					cartProductsData.push(productData)
	// 				})
	// 				sessionStorage.setItem('cartProductsData', JSON.stringify(cartProductsData))
	// 				updateCartItems(cartItems, cartProductsData)
	// 			})
	// 	} else {
	// 		updateCartItems(cartItems, cartProductsData)
	// 	}
	// }

	// function updateCartItems(cartItems, cartProductsData) {
	// 	cartItems.forEach((item) => {
	// 		const itemSku = item.getAttribute('data-micro-sku') || item.innerHTML
	// 		const matchingProductData = cartProductsData.find((productData) => productData.sku === itemSku)
	// 		if (matchingProductData) {
	// 			item.innerHTML = matchingProductData.imageHTML + item.innerHTML
	// 		}
	// 	})
	// }

	// const observer = new MutationObserver((mutationsList, observer) => {
	// 	for (let mutation of mutationsList) {
	// 		if (mutation.type === 'childList') {
	// 			const images = document.querySelectorAll('.cart-item a img')
	// 			images.forEach((img) => {
	// 				if (img.getAttribute('data-src')) {
	// 					img.src = img.getAttribute('data-src')
	// 				}
	// 			})
	// 			const links = document.querySelectorAll('.cart-item a')
	// 			links.forEach((link) => {
	// 				if (link.querySelector('img')) {
	// 					link.classList.add('product-icon')
	// 				}
	// 			})
	// 		}
	// 	}
	// })

	// observer.observe(document.body, { childList: true, subtree: true })
}

// POPUP CART
document.addEventListener('ShoptetDOMCartContentLoaded', () => {
	const currencyLabel = dataLayer[0].shoptet.currencyInfo.symbol
	const cartWidgetProducts = document.querySelectorAll('.cart-widget-product')
	if (cartWidgetProducts.length) {
		cartWidgetProducts.forEach((product) => {
			const productPrice = product.querySelector('span[data-testid="cartWidgetProductPrice"]')
			if (productPrice) {
				const priceEl = document.createElement('div')
				priceEl.classList.add('cart-widget-product-price')
				priceEl.appendChild(productPrice)
				product.appendChild(priceEl)
				const productSKU = product.getAttribute('data-micro-sku')
				if (productSKU) {
					const productSinglePrice = dataLayer[0].shoptet.cart.filter((item) => item.code === productSKU)[0].priceWithVat
					const productSinglePriceEl = document.createElement('div')
					productSinglePriceEl.classList.add('cart-widget-product-single-price')
					productSinglePriceEl.innerHTML = `${productSinglePrice} ${currencyLabel} / ks` //jazyk
					priceEl.appendChild(productSinglePriceEl)
				}
			}
		})
	}

	let popupCartSummary = document.querySelector('.popup-cart-summary')
	if (!popupCartSummary) {
		popupCartSummary = document.createElement('div')
		popupCartSummary.classList.add('popup-cart-summary')
	}
	let popupCartSummaryPriveVAT = String(dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat)
	if (popupCartSummaryPriveVAT.includes('.')) {
		popupCartSummaryPriveVAT = popupCartSummaryPriveVAT.replace('.', ',')
	}

	let popupCartSummaryPriceNoVAT = String(dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat)
	if (popupCartSummaryPriceNoVAT.includes('.')) {
		popupCartSummaryPriceNoVAT = popupCartSummaryPriceNoVAT.replace('.', ',')
	}
	// console.log(popupCartSummaryPriceNoVAT)

	// Převod řetězce na číslo
	let popupCartSummaryPriceNoVATNumber = parseFloat(popupCartSummaryPriceNoVAT.replace(',', '.'))

	popupCartSummary.innerHTML = `
    <div class="popup-cart-summary-item">
        <strong class="popup-cart-summary-item-label">Celkem za zboží</strong>
        <strong class="popup-cart-summary-item-value">${popupCartSummaryPriveVAT} ${currencyLabel}</strong>
    </div>
    <div class="popup-cart-summary-item">
        <span class="popup-cart-summary-item-label">Celkem bez DPH</span>
        <span class="popup-cart-summary-item-value">${Math.round(popupCartSummaryPriceNoVATNumber)} ${currencyLabel}</span>
    </div>
` //jazyk
	const cartWidgetProductsWrapper = document.querySelector('.cart-widget-products')
	if (cartWidgetProductsWrapper)
		cartWidgetProductsWrapper.parentElement.insertBefore(popupCartSummary, cartWidgetProductsWrapper.nextElementSibling)

	const cartWidgetButton = document.querySelector('.cart-widget-button')
	const cartWidgetInner = document.querySelector('.cart-widget-inner')
	if (cartWidgetButton && cartWidgetInner) cartWidgetInner.appendChild(cartWidgetButton.cloneNode(true))

	const cartWidgetShipping = document.querySelector('.cart-free-shipping')
	if (cartWidgetShipping) {
		const priceLeftToFreeShipping = dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft
		if (priceLeftToFreeShipping > 0) {
			const freeShippingBar = document.createElement('div')
			const freeShippingValue = document.createElement('div')
			freeShippingBar.classList.add('price-range')
			freeShippingBar.appendChild(freeShippingValue)

			popupCartSummaryPriveVAT = Number(popupCartSummaryPriveVAT);

			freeShippingValue.style.width = `${100 - (100 * priceLeftToFreeShipping) / (priceLeftToFreeShipping + popupCartSummaryPriveVAT)}%`;
			cartWidgetShipping.appendChild(freeShippingBar)
			const shippingWidgetStrongs = cartWidgetShipping.querySelectorAll('strong')
			if (shippingWidgetStrongs.length) {
				shippingWidgetStrongs.forEach((strong) => {
					if (strong.innerText.includes('ZDARMA')) strong.classList.add('free-shipping-strong') //jazyk
				})
			}
		}
	}
})
// document.addEventListener('ShoptetCartUpdated', () => {
// 	const popupCartSummary = document.querySelector('.popup-cart-summary')
// 	console.log(popupCartSummary)
// 	// const popupCartSummaryPriveVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
// 	// const popupCartSummaryPriceNoVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
// 	// const popupCartPriceVAT = popupCartSummary.querySelector('strong.popup-cart-summary-item-value')
// 	// const popupCartPriceNoVAT = popupCartSummary.querySelector('span.popup-cart-summary-item-value')
// 	// popupCartPriceVAT.innerHTML = `${popupCartSummaryPriveVAT} ${currencyLabel}`
// 	// popupCartPriceNoVAT.innerHTML = `${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}`
// })

// ADVANCED ORDER
document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
	const advancedOrder = document.querySelector('.advanced-order')
	const aoTop = document.createElement('div')
	aoTop.classList.add('ao-top')
	advancedOrder.prepend(aoTop)
	const aoTitle = advancedOrder.querySelector('.h1')
	if (aoTitle) aoTop.appendChild(aoTitle)
	const aoProduct = advancedOrder.querySelector('.ao-product') || advancedOrder.querySelector('.h2')
	if (aoProduct) aoTop.appendChild(aoProduct)
	const cboxClose = document.querySelector('#cboxClose')
	if (cboxClose) {
		cboxClose.innerText = 'Zavřít' //jazyk
		cboxClose.id = 'cboxClose'
		cboxClose.classList.add('close')
		// aoTop.appendChild(cboxClose)
	}
	const continueShoppingBtn = document.createElement('button')
	continueShoppingBtn.classList.add('btn', 'black-border')
	continueShoppingBtn.innerText = 'Zavřít' //jazyk
	continueShoppingBtn.addEventListener('click', () => {
		shoptet.modal.close()
	})
	const extraStep = advancedOrder.querySelector('.extra.step')
	if (extraStep) extraStep.prepend(continueShoppingBtn)

	const deliveryStrongs = advancedOrder.querySelectorAll('.extra.delivery strong')
	if (deliveryStrongs.length) {
		deliveryStrongs.forEach((strong) => {
			if (strong.innerText === 'ZDARMA') strong.classList.add('for-free') //jazyk
		})
	}
	const suggestion = advancedOrder.querySelector('.advanced-order-suggestion')
	if (suggestion) {
		suggestion.innerHTML = 'Můžete ještě přidat ...'
	}
	const img = advancedOrder.querySelector('.ao-product .ao-image img')
	if (img) {
		img.src = img.getAttribute('data-src')
	}

	const advancedOrderProducts = $('.colorbox-html-content #products')
	if (advancedOrderProducts.length) {
		advancedOrderProducts.slick(productsSlickSettings)
	}
})

// EMPTY CART





const handleEmptyCart = () => {
	const emptyCart = document.querySelector('.cart-inner.cart-empty');
	document.body.classList.add('custom-empty-cart');
	const cartHeading = emptyCart.querySelector('.cart-heading');
	const cartText = document.createElement('p');
	cartText.classList.add('narrow-custom', 'text-center');
	const prazdnyKosikPerexText = window.prazdnyKosikPerex.find((item) => item.language === shoptetLang).text;
	cartText.innerText = prazdnyKosikPerexText;
	if (cartHeading) {
		const prazdnyKosikNadpisText = window.prazdnyKosikNadpis.find((item) => item.language === shoptetLang).text;
		cartHeading.innerText = prazdnyKosikNadpisText;
		cartHeading.classList.add('homepage-group-title');
		cartHeading.parentElement.insertBefore(cartText, cartHeading.nextElementSibling);
	}
	const cartEmail = emptyCart.querySelector('.mail');
	const cartPhone = emptyCart.querySelector('.tel');
	const cartContact = document.createElement('ul');
	cartContact.classList.add('cart-contact', 'contact-box');
	if (cartPhone) {
		cartContact.appendChild(cartPhone.parentElement);
	}
	if (cartEmail) {
		const emailPerexText = window.emailPerexText.find((item) => item.language === shoptetLang).text;
		const emailPerex = document.createElement('span');
		emailPerex.innerText = emailPerexText;
		cartEmail.parentElement.insertBefore(emailPerex, cartEmail.nextElementSibling);
		cartContact.appendChild(cartEmail.parentElement);
	}
	emptyCart.appendChild(cartContact);

	// Přidání btn holder s dvěma odkazy
	const btnHolder = document.createElement('div');
	btnHolder.classList.add('btn-holder', 'text-center');

	const primaryButton = window.primaryButtonText.find((item) => item.language === shoptetLang);
	const secondaryButton = window.secondaryButtonText.find((item) => item.language === shoptetLang);

	btnHolder.innerHTML = `
        <a href="${primaryButton.url}" class="btn btn-primary">${primaryButton.text}</a>
        <a href="${secondaryButton.url}" class="btn secondary">${secondaryButton.text}</a>
    `;

	emptyCart.appendChild(btnHolder);

	const emptyCartHeader = document.querySelector('.cart-header-wrapper');
	if (emptyCartHeader) emptyCartHeader.remove();
};

const emptyCart = document.querySelector('.cart-inner.cart-empty');
if (emptyCart) handleEmptyCart();

document.addEventListener('ShoptetDOMCartContentLoaded', () => {
	if (!dataLayer[0].shoptet.cart.length) handleEmptyCart();
});

// EMPTY CART POPUP
// const handleEmptyCartPopup = () => {
// 	const isEmpty = document.querySelector('.cart-widget .place-cart-here')
// 	if (isEmpty) {
// 		const toggleCart = document.querySelector('.toggle-window.cart-count')
// 		if (toggleCart) {
// 			toggleCart.addEventListener('mouseenter', () => document.body.classList.add('user-action-visible', 'cart-window-visible'))
// 			// toggleCart.addEventListener('mouseleave', () => document.body.classList.remove('user-action-visible', 'cart-window-visible'))
// 		}
// 		const cartLoader = isEmpty.querySelector('.loader-overlay')
// 		if (cartLoader) cartLoader.remove()
// 		const emptyCartPopup = document.createElement('div')
// 		emptyCartPopup.classList.add('empty-cart-popup')

// 		emptyCartPopup.innerHTML = `
// 			<h2>Ve vašem košíku nemáte žádné zboží</h2>
// 			<p>Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte Majyi, která Vám s výběrem velmi ráda pomůže.</p>
// 			<div class="contact-box phone-placeholder">
// 			</div>
// 			<div class="contact-box mail-placeholder">
// 				<span>Odpovídáme do 24 hodin</span>
// 			</div>
// 			<p>Nebo přejděte na naše kategorie</p>
// 			<ul class="subcategories">
// 			</ul>
// 		` //jazyk
// 		if (typeof emptyCartSubcategories !== 'undefined') {
// 			const subcategoriesWrapper = emptyCartPopup.querySelector('.subcategories')
// 			emptyCartSubcategories.forEach((subcategory) => {
// 				const subcategoryEl = document.createElement('li')
// 				subcategoryEl.innerHTML = `
// 					<a href="${subcategory.link}">
// 						<span class="text">${subcategory.text}</span>
// 						<span class="image">
// 							<img src="${subcategory.image}" alt="" />
// 						</span>
// 					</a>
// 				`
// 				subcategoriesWrapper.appendChild(subcategoryEl)
// 			})
// 		}
// 		isEmpty.appendChild(emptyCartPopup)
// 		const projectMail = document.querySelector('.contact-box .mail')
// 		const projectPhone = document.querySelector('.contact-box .tel')
// 		const phonePlaceholder = emptyCartPopup.querySelector('.phone-placeholder')
// 		const mailPlaceholder = emptyCartPopup.querySelector('.mail-placeholder')
// 		if (projectPhone) {
// 			phonePlaceholder.appendChild(projectPhone.cloneNode(true))
// 			// if (headerOpeningHours) {
// 			// 	const phonePerex = document.createElement('span')
// 			// 	phonePerex.innerText = headerOpeningHours
// 			// 	phonePlaceholder.appendChild(phonePerex)
// 			// }
// 		}
// 		if (projectMail) {
// 			mailPlaceholder.prepend(projectMail.cloneNode(true))
// 		}
// 	}
// }
// handleEmptyCartPopup()
window.addEventListener('beforeunload', function (event) {
	window.sessionStorage.removeItem('openedFilters')
})

// const backToTop = document.querySelector('#back-to-top')
// if (backToTop) {
// 	backToTop.addEventListener('click', (e) => {
// 		e.preventDefault()
// 		window.scrollTo(0, 0)
// 	})
// }

const handleFooter = async () => {
	// const socialIcons = document.querySelector('.footer-links-icons')
	// const contactBanner = document.querySelector('.custom-footer__contact')
	// if (socialIcons && contactBanner) contactBanner.appendChild(socialIcons)
	const cookies = document.querySelector('.js-cookies-settings')
	if (cookies) {

	}
	const signature = document.querySelector('#signature')
	if (signature) {
		const mirandaMediaLink = `
			<a class="company" href="https://www.mirandamedia.cz/shoptetnamiru" target="_blank">
				<img class="company__logo" src="/user/documents/miranda.svg">
				MirandaMedia Group s.r.o.
			</a>
		`
		signature.insertAdjacentHTML('beforeend', mirandaMediaLink)
	}
	const footerHeadings = document.querySelectorAll('.banner-wrapper > span > h4')
	footerHeadings.forEach((heading) => {
		heading.classList.add('clickable')
		heading.addEventListener('click', () => {
			heading.closest('.banner-wrapper').classList.toggle('active')
		})
	})
	const footerCategories = document.querySelector('.custom-footer__categories > h4')
	if (footerCategories) {
		footerCategories.classList.add('clickable')
		footerCategories.addEventListener('click', () => {
			footerCategories.closest('.custom-footer__categories').classList.toggle('active')
		})
	}
	const instagram = document.querySelector('.custom-footer__instagram');
	const footer = document.querySelector('#footer');
	if (instagram && footer) {
		const h4 = instagram.querySelector('h4');
		h4.classList.add('homepage-group-title');
		const h4Text = window.instagramTitle.find(group => group.language === shoptetLang);
		if (h4 && h4Text) {
			h4.innerHTML = h4Text.text;
		}
		const instagramWrapper = instagram.querySelector('.instagram-widget');
		footer.before(instagram);
		const allPosts = instagramWrapper.querySelectorAll('a');
		allPosts.forEach((post) => {
			const div = document.createElement('div');
			const img = document.createElement('img');
			img.src = "/user/documents/upload/miranda/logo-small-big.svg";

			div.appendChild(img);
			post.appendChild(div);
		});
		// $('.custom-footer__instagram .instagram-widget').slick({
		// 	arrows: true, // No arrows
		// 	dots: false, // No dots
		// 	infinite: true,
		// 	slidesToShow: 6,
		// 	slidesToScroll: 1,
		// 	responsive: [
		// 		{
		// 			breakpoint: 1350,
		// 			settings: {
		// 				slidesToShow: 5,
		// 				infinite: true,
		// 			},
		// 		},
		// 		{
		// 			breakpoint: 1100,
		// 			settings: {
		// 				slidesToShow: 4,
		// 				infinite: false,
		// 			},
		// 		},
		// 		{
		// 			breakpoint: 768,
		// 			settings: {
		// 				slidesToShow: 3,
		// 				infinite: false,
		// 			},
		// 		},

		// 	],
		// });
	}
	const siteName = document.querySelector('#footer .site-name');
	const customFooter = document.querySelector('#footer .custom-footer');
	if (customFooter) {
		customFooter.insertBefore(siteName, customFooter.firstChild);
	}
	const customFooterContact = document.querySelector('#footer .custom-footer__contact')
	const customFooterContactPlaceholder = document.querySelector('#footer .contacts-placeholder')
	if (customFooterContact && customFooterContactPlaceholder) {
		customFooterContactPlaceholder.append(customFooterContact)
	}

	// const footeSiteNameImg = document.querySelector('#footer .site-name img')
	// if (footeSiteNameImg) {
	// 	footeSiteNameImg.src = '/user/documents/upload/miranda/logo-footer.svg'
	// }
	// const socialBanner = document.querySelector('.social-wrapper')
	// if (socialBanner) {
	// 	siteName.appendChild(socialBanner)
	// }
}
handleFooter()


// const shoptetPage = dataLayer[0].shoptet.pageType
// const shoptetLang = dataLayer[0].shoptet.language

// const handleUSP = () => {
// 	const benefitBanner = document.querySelector('.benefitBanner')
// 	if (benefitBanner) {
// 		if (dataLayer[0].shoptet.pageType === 'homepage') {
// 			const firstProductsBlock = document.querySelectorAll('.products-block')
// 			if (firstProductsBlock.length)
// 				firstProductsBlock[0].parentElement.insertBefore(benefitBanner, firstProductsBlock[0].nextElementSibling)
// 		}
// 	}
// }
// handleUSP()

// const handleHomepageProducts = async () => {
// 	const productBlocks = document.querySelectorAll('.products-block');
// 	if (productBlocks.length > 0) {
// 		$(productBlocks[0]).slick(productsSlickSettings);
// 	}

// }
if (shoptetPage === 'homepage') {

	// if (window.innerWidth > 767) {
	const updateControlsPosition = () => {
		const container = document.querySelector('.container')
		const marginLeftValue = window.getComputedStyle(container).marginLeft
		const newLeftValue = parseInt(marginLeftValue) + 76 + 'px'
		const carouselControlRight = document.querySelector('.carousel-control.right')
		if (carouselControlRight) carouselControlRight.style.right = parseInt(marginLeftValue) + 20 + 'px'
		const carouselControlLeft = document.querySelector('.carousel-control.left')
		if (carouselControlLeft) carouselControlLeft.style.right = newLeftValue;

		// Update for each .extended-banner-texts inside #carousel .carousel-inner .item
		// const extendedBannerTexts = document.querySelectorAll('#carousel .carousel-inner .item .extended-banner-texts')
		// extendedBannerTexts.forEach((text) => {
		// 	text.style.left = newLeftValue
		// })
	}

	updateControlsPosition()
	window.addEventListener('resize', updateControlsPosition)
	document.addEventListener('ShoptetDOMContentLoaded', updateControlsPosition)
	// }


	const productsSelectors = () => {
		const allProducts = document.querySelectorAll('.products');

		if (!allProducts) return;

		const productsIDs = [];

		for (const products of allProducts) {
			// if (index === 0) continue;

			productsIDs.push(`#${products.id}`);
		}
		// console.log(productsIDs)
		return productsIDs;
	}

	swiperize({
		containers: [
			...productsSelectors(),
		],
		slide: [
			swiperize.spreadClass(productsSelectors(), '.product'),
		],
		customOptions: {
			fullscreen: false,
			infinity: true,
			dots: false,
			arrows: true,
			scrollbar: false,
			lazyPrevNext: true
		},
		swiperOptions: {
			direction: 'horizontal',
			speed: 800,
			slidesPerView: 1,
			spaceBetween: 16,

			breakpoints: {
				1300: {
					slidesPerView: 4,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				993: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
				600: {
					slidesPerView: 2,
					spaceBetween: 16,
				},

			},
		},
	});


	function homePageSections() {
		let headingElements = document.querySelectorAll('.homepage-group-title');
		let insertAfterElement = document.querySelector('.before-carousel');

		if (document.querySelector("body").classList.contains("mobile")) {
			insertAfterElement = document.querySelector('.banners-row');
		}

		headingElements.forEach((heading, index) => {
			let splitClass = heading.className.split('homepage-products-heading-');
			if (splitClass.length > 1) {
				let headingNumber = splitClass[1].split(' ')[0];
				let productElement = document.querySelector(`.homepage-products-${headingNumber}`);

				if (productElement) {
					const section = document.createElement('section');
					section.classList.add('product-section', `product-section-${headingNumber}`);

					// Přidání třídy rolex-products, pokud je titulek Rolex
					if (heading.textContent.trim() === 'Rolex') {
						section.classList.add('rolex-products');
					}

					const container = document.createElement('div');
					container.classList.add('container');

					section.appendChild(container);
					container.appendChild(heading);
					container.appendChild(productElement);

					if (insertAfterElement) {
						insertAfterElement.insertAdjacentElement('afterend', section);
						insertAfterElement = section; // Aktualizujeme insertAfterElement na nově vloženou sekci
					}
				}
			}
		});
	}
	homePageSections();

	// Příklad pole s hodnotami
	const links = [
		{
			language: 'cs', links: [
				{ name: 'Zobrazit více', url: '/nase-nabidka/', index: 0 },
				{ name: 'Na značku', url: '/rolex/', index: 1 }
			]
		},
		{
			language: 'en', links: [
				{ name: 'See more', url: '/all-watches/', index: 0 },
				{ name: 'To brand', url: '/rolex/', index: 1 }
			]
		}
	];

	const handleSectionLinks = () => {
		const productSections = document.querySelectorAll('.product-section');

		productSections.forEach((section, index) => {
			const container = section.querySelector('.container');

			const languageGroup = links.find(group => group.language === shoptetLang);
			if (languageGroup) {
				const link = languageGroup.links.find(link => link.index === index);
				if (link) {
					const button = document.createElement('a');
					button.classList.add('btn', 'secondary', 'more-products');
					button.href = link.url;
					button.textContent = `${link.name}`;
					container.appendChild(button);
				}
			}
		});
	};

	// Volání funkce
	handleSectionLinks();


	// Volání funkce
	moveElement('.chrono-banner', ['.before-carousel', '.banners-row']);
	moveElement('.our-brands', ['.chrono-banner', '.before-carousel', '.banners-row']);
	moveElement('.vykup-hodinek', ['.our-brands', '.before-carousel', '.banners-row']);
	moveElement('.our-partners', ['.vykup-hodinek', '.our-brands', '.before-carousel', '.banners-row']);
	moveElement('.faq-section:not(.vykup)', ['.product-section', '.our-partners', '.vykup-hodinek']);
	moveElement('#form-section', ['.product-section', '.our-partners', '.vykup-hodinek']);


}


//Naše značky hover animace
if (animaceNaseZnacky === true) {


	let hoverTimeout;
	on('mouseover', '.our-brands .flex-holder .single-brand', function () {
		hoverTimeout = setTimeout(() => {
			this.classList.add('active');

			let siblings = Array.from(this.parentElement.children).filter(el => el !== this);

			siblings.forEach(sibling => sibling.classList.remove('active'));
		}, 100);
	});

	on('mouseout', '.our-brands .flex-holder .single-brand', function () {
		clearTimeout(hoverTimeout);
	});
}
on("click", ".question h3", function (e) {
	const content = this.closest(".question");
	this.classList.toggle("active");
	content.classList.toggle("active");
});

function addEmptySlides(selector, rules) {
	const swiperWrapper = document.querySelector(`${selector} .swiper-wrapper`);
	if (swiperWrapper) {
		rules.sort((a, b) => b.width - a.width);
		const applicableRule = rules.find(rule => window.innerWidth > rule.width);

		if (applicableRule) {
			for (let i = 0; i < applicableRule.emptySlidesCount; i++) {
				const emptySlide = document.createElement('div');
				emptySlide.classList.add('swiper-slide');
				swiperWrapper.appendChild(emptySlide);
			}
		}
	}
}

// ANIMACE
let target = document.querySelectorAll('.products-block')
const target2 = document.querySelector('.top-categories-grid')
function handleIntersection(entries) {
	entries.map((entry, index) => {
		entry.target.style.removeProperty('--animation-delay')
		entry.target.setAttribute(
			'style',
			entry.target.getAttribute('style')
				? entry.target.getAttribute('style') + `--animation-delay: ${index}`
				: `--animation-delay: ${index}`
		)
		// entry.target.setAttribute('animation-delay', `${index}`)
		if (entry.isIntersecting) {
			entry.target.classList.add('visible')
		}
	})
}
const observer = new IntersectionObserver(handleIntersection)
const observer2 = new IntersectionObserver(handleIntersection)
if (target.length) {
	target.forEach((item) => {
		item.classList.add('animation')
		const subtargets = item.querySelectorAll('.product')
		subtargets.forEach((subtarget) => {
			observer.observe(subtarget)
		})
	})
}
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', () => {
	if (target.length) {
		target.forEach((item) => {
			item.classList.add('animation')
			const subtargets = item.querySelectorAll('.product')
			subtargets.forEach((subtarget) => {
				observer.observe(subtarget)
			})
		})
	}
})
if (target2) {
	target2.classList.add('animation')
	const subtargets = target2.querySelectorAll('.category')
	subtargets.forEach((subtarget) => {
		observer2.observe(subtarget)
	})
}


const handleCustomDetail = () => {
	// Najít .basic-description a obalit obsah divem .content-wrapper
	const basicDescription = document.querySelector('.basic-description');
	if (basicDescription) {
		const contentWrapper = document.createElement('div');
		contentWrapper.classList.add('content-wrapper');

		while (basicDescription.firstChild) {
			contentWrapper.appendChild(basicDescription.firstChild);
		}

		// Najít předposlední .p-thumbnail img a vytvořit img element
		const thumbnails = document.querySelectorAll('.p-thumbnail img');
		if (thumbnails.length) {
			const img = document.createElement('img');
			const imgSrc = thumbnails[thumbnails.length - 2].getAttribute('data-src');
			const origSrc = imgSrc.replace('/related/', '/orig/');
			img.src = origSrc;
			img.classList.add('side-detail-img');
			basicDescription.appendChild(img);
		}

		basicDescription.appendChild(contentWrapper);
	}

	// Najít .extended-description .detail-parameters a přidat třídu .content-wrapper

	const detailParameters = document.querySelector('.extended-description');
	if (detailParameters) {
		const contentWrapper = document.createElement('div');
		contentWrapper.classList.add('content-wrapper');

		while (detailParameters.firstChild) {
			contentWrapper.appendChild(detailParameters.firstChild);
		}

		// Najít první h3 a přepsat jeho innerHTML
		const firstH3 = detailParameters.querySelector('h3');
		if (firstH3) {
			const specificationText = window.specificationTabText.find(item => item.language === shoptetLang).text;
			firstH3.innerHTML = specificationText;
		}

		// Najít poslední .p-thumbnail img a vytvořit img element
		const thumbnails = document.querySelectorAll('.p-thumbnail img');
		if (thumbnails.length) {
			const img = document.createElement('img');
			const imgSrc = thumbnails[thumbnails.length - 1].getAttribute('data-src');
			const origSrc = imgSrc.replace('/related/', '/orig/');
			img.src = origSrc;
			img.classList.add('side-detail-img');
			detailParameters.appendChild(img);
		}

		detailParameters.appendChild(contentWrapper);
	}
	const firstH3 = document.querySelector('.extended-description h3');
	if (firstH3) {
		const specificationText = window.specificationTabText.find(item => item.language === shoptetLang).text;
		firstH3.innerHTML = specificationText;
	}
	const productVideos = document.querySelector('#productVideos');
	if (productVideos) {
		const videoText = basicDescription.querySelector('.video-popis');
		const heading = productVideos.querySelector('h3'); // Předpokládám, že nadpis je h3, upravte podle potřeby
		const iframe = productVideos.querySelector('iframe');
		if (iframe) {
			iframe.classList.add('side-detail-img');
		}
		if (heading) {
			const contentWrapper = document.createElement('div');
			contentWrapper.classList.add('content-wrapper');

			contentWrapper.appendChild(heading);

			if (videoText) {
				contentWrapper.appendChild(videoText);
			}

			productVideos.insertBefore(contentWrapper, productVideos.firstChild);
		}
	}

	// Odstranění diskuse
	const discussionWrapper = document.querySelector('#productDiscussion');
	if (discussionWrapper) {
		discussionWrapper.remove();
	}
	const shpTab = document.querySelector('.shp-tab[data-testid="tabDiscussion"]');
	if (shpTab) {
		shpTab.remove();
	}
	moveElement('#form-section', ['.p-detail']);
	moveElement('.faq-section:not(.vykup)', ['#form-section', '.p-detail']);

	moveElement('.chrono-banner', ['.p-detail']);


}

if (shoptetPage === 'productDetail') handleCustomDetail();




if (window.innerWidth < 768) {
	const topNavigationBarMenu = document.querySelector('.top-navigation-bar-menu');
	const navigationIn = document.querySelector('#navigation .navigation-in');

	if (topNavigationBarMenu && navigationIn) {
		navigationIn.appendChild(topNavigationBarMenu);
	}
}



$(document).on("click", ".shp-tab-link", function (e) {
	var target = $(this).attr("href");
	if ($(target).length > 0) {
		e.preventDefault();
		$("html,body").animate({
			scrollTop: $(target).offset().top - 150
		}, 700);
	}
});



on("click", ".f-field-group label", function (e) {
	const clossest = this.closest('.f-field-group');
	const input = clossest.querySelector('input');
	input.style.display = 'block';
});


//Custom stránky

if (body.classList.contains("id-720")) {
	moveElement('.faq-section.vykup', ['.process-byout', '.title-section']);
	moveElement('.our-brands', ['.form-section.vykup', '.faq-section.vykup', '.process-byout', '.title-section']);

	// Najde a odstraní element s třídou .custom-footer__banner18
	const customFooterBanner = document.querySelector('.custom-footer__banner18');
	if (customFooterBanner) {
		customFooterBanner.remove();
	}
}
if (body.classList.contains("id-723")) {
	moveElement('.faq-section:not(.vykup)', ['.title-section']);
	moveElement('.faq-section.vykup', ['.banner-section', '.faq-section:not(.vykup)', '.title-section']);
	moveElement('.our-brands', ['.faq-section.vykup', '.banner-section', '.faq-section:not(.vykup)', '.title-section']);
}

if (body.classList.contains("id-726")) {
	moveElement('.our-brands', ['.form-section.kontakt', '.banner-section', '.faq-section:not(.vykup)', '.title-section']);

	const customFooterBanner = document.querySelector('.custom-footer__banner18');
	if (customFooterBanner) {
		customFooterBanner.remove();
	}

}

if (body.classList.contains("id-29")) {
	const customFooterBanner = document.querySelector('.custom-footer__banner18');
	if (customFooterBanner) {
		customFooterBanner.remove();
	}
}

if (shoptetPage === 'category') {
	moveElement('#form-section', ['.content-wrapper', '.our-partners', '.vykup-hodinek']);
	document.addEventListener('ShoptetDOMPageContentLoaded', function () {
		moveElement('#form-section', ['.content-wrapper', '.our-partners', '.vykup-hodinek']);
	});

	document.addEventListener('ShoptetDOMContentLoaded', function () {
		moveElement('#form-section', ['.content-wrapper', '.our-partners', '.vykup-hodinek']);
	});
}
if (document.querySelector("body").classList.contains("id-729")) {
	document.addEventListener('dkLabFavouriteProductsLoaded', function () {
		console.log('dkLabFavouriteProductsLoaded');
		const mmAllProducts = document.querySelectorAll('.product');
		if (mmAllProducts.length) {
			mmAllProducts.forEach((product) => handleFlags(product))
			mmAllProducts.forEach((product) => handleTextLayout(product))
			// mmAllProducts.forEach((product) => handleProductAvailability(product));
		}
	});
}
// Naposledy prohlížené
function handleLastVisitedProducts() {

	const lastViewedProducts = document.querySelector('.dvpnProducts');
	const instagramSection = document.querySelector('.custom-footer__instagram') || document.querySelector('#footer');


	if (lastViewedProducts && instagramSection) {
		const visitedProductsContainer = lastViewedProducts.closest('.dkLabVisitedProductsNew');

		if (visitedProductsContainer) {
			const containerDiv = document.createElement('div');
			containerDiv.classList.add('container');
			containerDiv.appendChild(visitedProductsContainer);

			instagramSection.parentNode.insertBefore(containerDiv, instagramSection);
			const lastVisitedSwiperized = document.querySelector('.swiper-dvpnProducts');
			// Inicializace swiperize
			if (!lastVisitedSwiperized) {
				swiperize({
					containers: '.dvpnProducts',
					slide: '.dvpnProducts__item',
					customOptions: {
						fullscreen: false,
						infinity: true,
						dots: false,
						arrows: true,
						scrollbar: false,
						lazyPrevNext: true
					},
					swiperOptions: {
						direction: 'horizontal',
						speed: 800,
						slidesPerView: 1,
						spaceBetween: 16,

						breakpoints: {
							1300: {
								slidesPerView: 4,
								spaceBetween: 24,
							},
							1024: {
								slidesPerView: 3,
								spaceBetween: 16,
							},
							993: {
								slidesPerView: 3,
								spaceBetween: 24,
							},
							600: {
								slidesPerView: 2,
								spaceBetween: 16,
							},

						},
					},
				});
			}

			const languageGroup = naposledyProhlizene.find(group => group.language === shoptetLang);

			if (visitedProductsContainer && languageGroup) {
				const h2Element = visitedProductsContainer.querySelector('h2');

				if (h2Element) {
					h2Element.textContent = languageGroup.text;
				}
			}
		}
	}
}


// document.addEventListener('dkLabLastVisitedProductsLoaded', handleLastVisitedProducts);
document.addEventListener('dkLabLastVisitedProductsChanged', handleLastVisitedProducts);


document.addEventListener('DOMContentLoaded', function () {
	// Funkce pro přidání třídy .hidden-files k .formeo-row-wrap obsahujícím .file-input
	function addHiddenFilesClass() {
		document.querySelectorAll('.file-input').forEach(function (fileInput) {
			fileInput.closest('.formeo-row-wrap').classList.add('hidden-files');
		});
	}

	// Přidáme třídu .hidden-files k existujícím .formeo-row-wrap obsahujícím .file-input
	addHiddenFilesClass();

	// Nastavení MutationObserver pro sledování změn v DOM
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.addedNodes.length) {
				addHiddenFilesClass();
				// Přidáme posluchač událostí na nový prvek #fake-file-input
				const fakeFileInput = document.querySelector('#fake-file-input');
				if (fakeFileInput) {
					fakeFileInput.addEventListener('change', handleFileInputChange);
				}
			}
		});
	});

	// Konfigurace MutationObserver
	const config = { childList: true, subtree: true };

	// Spuštění MutationObserver na celém dokumentu
	observer.observe(document.body, config);

	// Funkce pro zpracování změny v input file
	function handleFileInputChange(event) {
		const files = event.target.files;
		const maxFiles = 6;
		const maxSize = 10 * 1024 * 1024; // 10 MB
		const maxTotalSize = 25 * 1024 * 1024; // 25 MB
		const validFiles = [];
		const invalidFiles = [];
		const fileInputs = document.querySelectorAll('.file-input');
		let totalSize = 0;
		let existingFilesCount = 0;

		// Zkontrolujeme počet již nahraných souborů
		fileInputs.forEach(function (fileInput) {
			if (fileInput.files.length > 0) {
				existingFilesCount++;
				totalSize += fileInput.files[0].size;
			}
		});

		console.log(files);

		// Zkontrolujeme soubory
		for (let i = 0; i < files.length; i++) {
			if (validFiles.length + existingFilesCount >= maxFiles) {
				invalidFiles.push(files[i].name);
				continue;
			}
			if (files[i].size <= maxSize) {
				if (totalSize + files[i].size <= maxTotalSize) {
					validFiles.push(files[i]);
					totalSize += files[i].size;
				} else {
					const kosikText = window.kosik.find((item) => item.language === shoptetLang).text;
					alert(kosikText);
					break;
				}
			} else {
				const maxFileSizeText = window.maxFileSize.find((item) => item.language === shoptetLang).text;
				alert(`${maxFileSizeText} ${files[i].name}`);
			}
		}

		// Zobrazíme upozornění s názvy souborů, které nebyly nahrány
		if (invalidFiles.length > 0) {
			const invalidFilesText = invalidFiles.join(', ');
			const maxFilesText = window.maxFiles.find((item) => item.language === shoptetLang).text;
			alert(`${maxFilesText} ${invalidFilesText}`);
		}

		// Rozdělíme soubory do volných inputů
		let inputIndex = 0;
		fileInputs.forEach(function (fileInput) {
			if (inputIndex >= validFiles.length) return;
			if (fileInput.files.length === 0) {
				const dt = new DataTransfer();
				dt.items.add(validFiles[inputIndex]);
				fileInput.files = dt.files;
				inputIndex++;
			}
		});

		// Aktualizujeme wrapper
		const wrapper = document.querySelector(".loaded-files-wrapper");
		wrapper.innerHTML = '';
		fileInputs.forEach(function (fileInput, index) {
			if (fileInput.files.length > 0) {
				const fileName = fileInput.files[0].name;
				const fileHtml = `
                    <div class="single-filename">
                        <span class="filename">${fileName}</span>
                        <div class="delete close small" data-file-index="0" data-input-index="${index}"></div>
                    </div>
                `;
				wrapper.insertAdjacentHTML('beforeend', fileHtml);
			}
		});
	}

	// Delegace události click na tlačítko delete
	document.addEventListener('click', function (event) {
		if (event.target.classList.contains('delete')) {
			const fileIndex = event.target.getAttribute('data-file-index');
			const inputIndex = event.target.getAttribute('data-input-index');
			const inputFile = document.querySelectorAll('.file-input')[inputIndex];

			// Odstraníme soubor z inputu
			const dt = new DataTransfer();
			const files = inputFile.files;

			for (let i = 0; i < files.length; i++) {
				if (i !== fileIndex) {
					dt.items.add(files[i]);
				}
			}

			inputFile.files = dt.files;

			// Odstraníme HTML element
			event.target.closest('.single-filename').remove();
		}
	});

	// Najde a odstraní element s třídou .custom-footer__banner18
	const customFooterBanner = document.querySelector('.custom-footer__banner18');
	if (customFooterBanner) {
		customFooterBanner.remove();
	}

	// Přidáme posluchač událostí na prvek #fake-file-input, pokud již existuje
	const fakeFileInput = document.querySelector('#fake-file-input');
	if (fakeFileInput) {
		fakeFileInput.addEventListener('change', handleFileInputChange);
	}

	// Funkce pro resetování fake-file-input a odstranění single-filename
	function resetFileInputAndFilenames() {
		const fakeFileInput = document.querySelector('#fake-file-input');
		if (fakeFileInput) {
			fakeFileInput.value = '';
		}
		document.querySelectorAll('.single-filename').forEach(function (element) {
			element.remove();
		});
	}

	// Nastavení MutationObserver pro sledování změn v DOM a kontrolu existence wt-success-message-wrapper
	const successObserver = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.addedNodes.length) {
				if (document.querySelector('.wt-success-message-wrapper')) {
					resetFileInputAndFilenames();
				}
			}
		});
	});

	// Spuštění MutationObserver na celém dokumentu
	successObserver.observe(document.body, config);
});


const handleNewsletter = () => {
	const newsLeter = document.querySelector('.custom-footer__newsletter');
	if (newsLeter) {
		const btn = newsLeter.querySelector('button');
		const header = newsLeter.querySelector(".newsletter-header")
		const title = header.querySelector('h4');
		const perex = document.createElement('p');
		if (perex && header) {
			header.appendChild(perex);
			if (newsLetterPerex) {
				const perexText = newsLetterPerex.find((item) => item.language === shoptetLang).text;
				perex.innerText = perexText;
			}
		}
		if (btn && newsLetterBtn) {
			const btnText = newsLetterBtn.find((item) => item.language === shoptetLang).text;
			btn.innerText = btnText;
		}
		if (title && newsLetterTitle) {
			const titleText = newsLetterTitle.find((item) => item.language === shoptetLang).text;
			title.innerText = titleText;
		}
	}

	if (body.classList.contains("id-723") || body.classList.contains("id-29") && newsLeter) {
		const section = document.createElement('section');
		const container = document.createElement('div');
		section.classList.add('newsletter-section');
		container.classList.add('container');
		section.appendChild(container);
		container.appendChild(newsLeter);
		const footer = document.querySelector(".custom-footer__instagram ") || document.querySelector('#footer');
		footer.before(section);
	}
};
handleNewsletter();